import React from 'react';
import Icon from '../Icon';
import svg from '../icons/chevron-left-thick.js';

const IconChevronLeftThick = (props) => <Icon {...props} svg={svg} />;

IconChevronLeftThick.displayName = 'IconChevronLeftThick';

export default IconChevronLeftThick;
